import _ from 'lodash'
import * as types from './mutation-types'
import MeetingsApi from '@/api/meeting'
import MeetingCategoriesApi from '@/api/meeting-categories'
import moment from 'moment'
import {convert2LocalTime} from '@/helpers'
import router from '@/router'

const localTime = moment.tz.guess()
const emptyCloser = () => {}
const DEFAULT_EXPECTED_STATUS = 'pending'

const fetchMeetingCategories = async ({commit}, {callbacks}) => {
  const res = await MeetingCategoriesApi.getAll()
    .catch((err) => typeof (callbacks.error) === 'function' ? callbacks.error(err) : emptyCloser)
  commit(types.SET_CATEGORIES, {categories: res.data.data})
}

const fetchMeetings = async ({commit}, {params, callbacks}) => {
  let date = ''
  let status = ''

  if (router.currentRoute.name === 'pending-meetings') {
    date = moment()
    status = 'pending'
  } else {
    date = params ? moment(`${params.year}-${params.month}-01`, 'YYYY-MM-DD') : moment(`${moment().year()}-${moment().month() + 1}-01`, 'YYYY-MM-DD')
    status = params ? params.status : 'all'
  }
  let dateStart = date.format('Y-MM-DD 00:00:00')
  let dateEnd = router.currentRoute.name === 'pending-meetings' ? null : date.endOf('month').format('Y-MM-DD HH:mm:ss')
  if (dateEnd) dateEnd = moment(dateEnd).add(1, 'days').format('YYYY-MM-DD 23:59:59')
  dateStart = moment(dateStart).subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
  const res = await MeetingsApi.get({
    category_ids: params ? params.categoryIds : null,
    date_start: dateStart,
    date_end: dateEnd,
    status
  })
    .catch((error) => {
      typeof (callbacks.error) === 'function' ? callbacks.error(error) : emptyCloser(error)
    })
  if (!res) return
  const meetings = res.data.data

  for (let i = 0; i < meetings.length; i++) {
    meetings[i].start_at = convert2LocalTime(meetings[i].start_at, localTime)
    meetings[i].end_at = convert2LocalTime(meetings[i].end_at, localTime)
  }

  if (params) commit(types.SET_SEARCH_PARAMS, {params})
  commit(types.SET_MEETINGS, {meetings})
}

const cancelMeeting = async ({commit}, {params, callbacks}) => {
  const id = params.id
  const message = params.message ? params.message : null
  const cancelType = params.cancel_type ? params.cancel_type : null
  const expectedStatus = params.expected_status || DEFAULT_EXPECTED_STATUS
  const res = await MeetingsApi.cancel(id, message, cancelType, expectedStatus)
    .catch((error) => typeof (callbacks.error) === 'function' ? callbacks.error(error) : emptyCloser(error))
  if (!res) return null
  const meeting = res.data.data
  commit(types.UPDATE_MEETING, {id, meeting, cancelType})
  return meeting
}

const acceptMeeting = async ({commit}, {id, expected_status, callbacks}) => {
  const expectedStatus = expected_status || DEFAULT_EXPECTED_STATUS
  const res = await MeetingsApi.accept(id, expectedStatus)
    .catch((error) => typeof (callbacks.error) === 'function' ? callbacks.error(error) : emptyCloser(error))
  if (!res) return null
  const meeting = res.data.data
  commit(types.UPDATE_MEETING, {id, meeting})
  return meeting
}

const loadmoreMeetings = async ({commit}, {params}) => {
  const res = await MeetingsApi.get(params)
  _.forEach(res.data.data, meeting => commit(types.SET_MEETING, {meeting}))
}

const storeMeeting = async ({commit}, {meeting}) => {
  const res = await MeetingsApi.store(meeting)
  commit(types.SET_MEETING, {meeting: res.data.data})
}

const updateMeeting = async ({commit}, {id, meeting, callbacks}) => {
  const res = await MeetingsApi.update(id, meeting)
    .catch((error) => typeof (callbacks.error) === 'function' ? callbacks.error(error) : emptyCloser(error))
  commit(types.UPDATE_MEETING, {id, meeting: res.data.data})
}

const removeMeeting = async ({commit}, id) => {
  commit(types.REMOVE_MEETING, {id})
}

export default {
  removeMeeting,
  fetchMeetingCategories,
  fetchMeetings,
  loadmoreMeetings,
  storeMeeting,
  updateMeeting,
  acceptMeeting,
  cancelMeeting
}



// WEBPACK FOOTER //
// ./src/store/modules/meetings/actions.js